// front/src/services/AuthServices/authServices.js
import instance from "../../api/Api";

/**
 * Legacy (SMS-only OTT flow)
 * - Kept for backward compatibility
 */
export const login = (data) => instance.post("/v1/auth/login/", data);
export const send_otp = (data) => instance.post("/v1/auth/send-otp/", data);
export const verify_phone = (data) => instance.post("/v1/auth/verify-otp/", data);

/**
 * New Auth Endpoints (Phone-based)
 */
export const login_password = (data) => instance.post("/v1/auth/login-password/", data);

export const login_otp_send = (data) => instance.post("/v1/auth/login-otp/send/", data);
export const login_otp_verify = (data) => instance.post("/v1/auth/login-otp/verify/", data);

export const signup = (data) => instance.post("/v1/auth/signup/", data);
export const signup_otp_send = (data) => instance.post("/v1/auth/signup-otp/send/", data);
export const signup_otp_status = (data) => instance.post("/v1/auth/signup-otp/status/", data);
export const signup_otp_verify = (data) => instance.post("/v1/auth/signup-otp/verify/", data);

/**
 * Forgot Password (Phone OTP)
 */
export const forgot_password_send_otp = (data) =>
  instance.post("/v1/auth/forgot-password/send-otp/", data);

export const forgot_password_reset = (data) =>
  instance.post("/v1/auth/reset-password/", data);

/**
 * Logout
 */
export const logout = (data) => instance.post("/v1/auth/logout/", data);

/**
 * Email verification
 */
export const send_email_verification = () =>
  instance.post("/v1/auth/send-email-verification/");

// ✅ FIX: send payload (otp) in request body
export const verify_email = (data) =>
  instance.post("/v1/auth/verify-email/", data);

/**
 * Submit reCAPTCHA token
 */
export const submit_recaptcha = (data) => instance.post("/v1/auth/recaptcha/", data);
